import { LIFECYCLE_STATUS } from '../shared/SkuEnumHelpers';

// Temporary client-side cap on requested_pickup_time_range while queryOrders allows wider spans.
// History looks back this many years; Today looks forward the same amount. Ideally we remove this
// clipping once product and API agree on unconstrained ranges.
export const MAX_REQUESTED_PICKUP_TIME_RANGE_YEARS = 2;

export const DEFAULT_PARTNER_ORDERS_PAGE_SIZE = 50;

// Set to true to show the Report user action in the orders dashboard and flyout
// SKU-513 Hide Report user button for alpha release
// After alpha, we will have a detailed flow for reporting users, and will re-enable this button and remove this constant.
export const SHOW_REPORT_USER_BUTTON = false;

export const PARTNER_ORDERS_TAB = {
  TODAY: 'today',
  HISTORY: 'history',
};

export const PARTNER_ORDERS_HISTORY_LIFECYCLE_FILTER_OPTIONS = [LIFECYCLE_STATUS.FULFILLED, LIFECYCLE_STATUS.CANCELLED];

export {
  LIFECYCLE_STATUS,
  MARKED_FULFILLED_TYPE,
  ORDER_ITEM_CANCELLATION_TYPE,
  PROCESSING_STATUS,
} from '../shared/SkuEnumHelpers';
